// import useReversedFeatureFlag from '@/utils/hooks/useFeatureFlag';

// const FEATURE_FLAG = 'PARTICIPANT_ACTIVITY_RANGE_DATE_INPUT';
const useParticipantActivityRangeInputFeatureFlag = () => {
  // const isAvailable = useReversedFeatureFlag(FEATURE_FLAG, {
  //   dev: true,
  //   uat: true,
  // });

  return true;
};

export default useParticipantActivityRangeInputFeatureFlag;
